import { Col, Modal, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../../assets/style/modalStyle/addAccount.scss";
import { useTranslation } from "react-i18next";
import { accountSelector } from "../../../../services/selector/index.";
import {
  setMsg,
  setOpenPUAddAcc,
} from "../../../../services/slice/AccountSlice";
import {
  containsWhitespace,
  isValidPass,
} from "../../../../utils/functionCommon";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import LabelInput from "../../LabelInput";
import InputText from "../../Input/InputText";
import InputPassWord from "../../Input/InputPassWord";
import SelectValue from "../../Selector/SelectValue";
import { valueSelectLicense } from "../../../../utils/ValueSelect";

const ModalAddUser = ({ handleSave }) => {
  const [error, setError] = useState({
    isError: false,
    msg: "",
    errorIn: "",
  });
  const { t } = useTranslation();

  const stateAcc = useSelector(accountSelector);
  const [dataAdd, setDataAdd] = useState({
    username: "",
    password: "",
    type: 3,
  });

  const { isOpenModalAdd, msg } = stateAcc;
  const dispatch = useDispatch();
  const handleCancel = async () => {
    dispatch(setMsg(""));
    dispatch(setOpenPUAddAcc(false));
  };
  useEffect(() => {
    if (stateAcc.isError) {
      setError({
        isError: stateAcc.isError,
        msg: msg,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msg]);
  const handleClick = () => {
    if (!dataAdd.username) {
      setError({
        isError: true,
        msg: "Tên tài khoản không được để trống",
        errorIn: "username",
      });
      return;
    }
    if (!dataAdd.password) {
      setError({
        isError: true,
        msg: "Mật khẩu không được để trống",
        errorIn: "pass",
      });
      return;
    }
    if (dataAdd.username.length < 5) {
      setError({
        isError: true,
        msg: "Tên tài khoản phải có độ dài tối thiểu 5 kí tự",
        errorIn: "username",
      });
      return;
    }
    if (containsWhitespace(dataAdd.username)) {
      setError({
        isError: true,
        msg: "Tên tài khoản không được chứa khoảng trắng",
        errorIn: "pass",
      });
      return;
    }
    if (containsWhitespace(dataAdd.password)) {
      setError({
        isError: true,
        msg: "Mật khẩu không được chứa khoảng trắng",
        errorIn: "pass",
      });
      return;
    }
    if (dataAdd.password.length < 8) {
      setError({
        isError: true,
        msg: "Mật khẩu phải có độ dài từ 8 kí tự trở lên",
        errorIn: "pass",
      });
      return;
    }
    if (!isValidPass(dataAdd.password)) {
      setError({
        isError: true,
        msg: "Mật khẩu phải chứa 4 kiểu ký tự (a-z, A-Z, 0-9, #?!@$%^&*-.)",
        errorIn: "pass",
      });
      return;
    }
    setError({
      isError: false,
      msg: "",
      errorIn: "",
    });
    handleSave(dataAdd);
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Thêm mới tài khoản"} />}
        centered
        open={isOpenModalAdd}
        className="warrperModalAddAcc"
        width={570}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={155}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={155}
              content={"Tạo tài khoản"}
              typeBtn="btnOrange"
              handleClick={handleClick}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Row align={"middle"} style={{ position: "relative" }}>
          <Col span={6}>
            <LabelInput text={"Tên tài khoản"} />
          </Col>
          <Col span={18}>
            <InputText
              maxLength={50}
              setText={(value) => setDataAdd({ ...dataAdd, username: value })}
              placeholder={"Nhập tên tài khoản"}
              typeInput={`${
                (error.isError && error.errorIn === "username") ||
                (error.isError && error.msg === "User already exists")
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
            />
          </Col>
        </Row>
        <Row align={"middle"} style={{ margin: "1.5rem 0" }}>
          <Col span={6}>
            <Tooltip
              arrow={false}
              overlayClassName="toolTipGuidePass"
              title={
                <div>
                  <span>
                    <TranslateText
                      text={"Mật khẩu phải thỏa mãn 3 điều kiện sau:"}
                    />
                  </span>
                  <ul className="listGuide">
                    <li className="listItem">
                      <TranslateText text={"Có độ dài từ 8 kí tự trở lên"} />
                    </li>
                    <li className="listItem">
                      <TranslateText text={"Không chứa khoảng trắng"} />
                    </li>
                    <li className="listItem">
                      <TranslateText
                        text={" Chứa 4 kiểu kí tự (a-z, A-Z, 0-9, #?!@$%^&*-.)"}
                      />
                    </li>
                  </ul>
                </div>
              }
              placement="bottom"
            >
              <span
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "end",
                  paddingRight: "2rem",
                  fontWeight: 500,
                  cursor: "pointer",
                }}
              >
                <TranslateText text={"Mật khẩu"} />
              </span>
              {/* <LabelInput text={"Mật khẩu"} /> */}
            </Tooltip>
          </Col>
          <Col span={18}>
            <InputPassWord
              setPassWord={(value) =>
                setDataAdd({ ...dataAdd, password: value })
              }
              typeInput={`${
                (error.errorIn === "pass" && error.isError) || !dataAdd.password
                  ? "checkEmptyText baseInput"
                  : "baseInput"
              }`}
              style={
                error.errorIn === "pass" && error.isError
                  ? { border: "1px solid red" }
                  : null
              }
              placeholder={"Nhập mật khẩu"}
            />
          </Col>
        </Row>
        <Row align={"middle"}>
          <Col span={6}>
            <LabelInput text={"Phân quyền"} />
          </Col>
          <Col span={18}>
            <SelectValue
              handleChange={(value) => setDataAdd({ ...dataAdd, type: value })}
              width={"100%"}
              defaultValue={"Post Admin"}
              type="base"
              optionsValue={valueSelectLicense}
              key="selectLicense"
            />
          </Col>
          {error.isError ? <small className="msg">{t(error.msg)}</small> : null}
        </Row>
      </Modal>
    </>
  );
};

export default ModalAddUser;
